import createIcon from '../../createIcon';

/**
 * @component @name FilterNone
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMyA1SDFWMjFDMSAyMi4xIDEuOSAyMyAzIDIzSDE5VjIxSDNWNVpNMjEgMUg3QzUuOSAxIDUgMS45IDUgM1YxN0M1IDE4LjEgNS45IDE5IDcgMTlIMjFDMjIuMSAxOSAyMyAxOC4xIDIzIDE3VjNDMjMgMS45IDIyLjEgMSAyMSAxWk0yMSAxN0g3VjNIMjFWMTdaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FilterNone = createIcon('FilterNone', [
  [
    'path',
    {
      d: 'M3 5H1V21C1 22.1 1.9 23 3 23H19V21H3V5ZM21 1H7C5.9 1 5 1.9 5 3V17C5 18.1 5.9 19 7 19H21C22.1 19 23 18.1 23 17V3C23 1.9 22.1 1 21 1ZM21 17H7V3H21V17Z',
      key: 'pfc1j',
    },
  ],
]);

export default FilterNone;
